export default "__VITE_ASSET__9ace1096__"